/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-05-25 09:17:44
 * @LastEditors: linxi
 * @LastEditTime: 2023-11-15 18:53:24
 */
import { Button, Modal, Space, TableColumnType } from "antd"
import { Dimen } from "../../models/dimen"
import React, { ReactElement, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"

export const Columns = (
  startIndex: number,
  timeFlag: any,
  data?: any,
): TableColumnType<any>[] => {
  const history = useHistory()

  const cols: TableColumnType<any>[] = [
    {
      title: "序号",
      key: "no",
      align: "center",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
      width: Dimen.Num,
    },
    {
      title: "类型",
      dataIndex: "selfType",
      align: "center",
      width: "8rem",
      key: "selfType",
      render: function Element(_, t) {
        return <span>{t.selfType === 1 ? "年度自查" : "季度自查"}</span>
      },
    },
    {
      title: "自查周期",
      dataIndex: "selfPeriod",
      align: "center",
      width: "8rem",
      key: "selfPeriod",
    },
    {
      title: "申请时间",
      dataIndex: "applicantTime",
      align: "center",
      width: "10rem",
      key: "applicantTime",
    },
    {
      title: "申情人",
      dataIndex: "applicantUserName",
      align: "center",
      width: "8rem",
      key: "applicantUserName",
    },
    {
      title: "审核时间",
      dataIndex: "reviewTime",
      align: "center",
      width: "8rem",
      ellipsis: true,
      key: "reviewTime",
    },
    {
      title: "状态",
      dataIndex: "reviewStatusName",
      align: "center",
      key: "reviewStatusName",
      width: "8rem",
      render: function Element(_, t) {
        return (
          <span
            style={{
              color:
                t.reviewStatus == 1
                  ? "#0CC263"
                  : t.reviewStatus == 2
                  ? "#9A9A9A"
                  : "#FAA440",
            }}
          >
            {t.reviewStatusName}
          </span>
        )
      },
    },
    {
      title: "退回原因",
      dataIndex: "memo",
      align: "center",
      width: "8rem",
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t.memo && (
            <Button
              type="link"
              size="small"
              onClick={() => {
                Modal.info({
                  title: "退回原因",
                  content: t.memo,
                  icon: null,
                  okText: "确认",
                  cancelText: "取消",
                  cancelButtonProps: { style: { display: "none" } },
                })
              }}
            >
              查看
            </Button>
          )
        )
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      width: Dimen.Price,
      render: function ShowAction(_, t): ReactElement | undefined {
        return (
          <Space>
            {t?.reviewStatus === 2 && (
              <Button
                size="small"
                type="link"
                onClick={() => {
                  history.push({
                    pathname: "/selfInspectionLegalPractice/add",
                    state: {
                      id: t.id,
                      type: 1,
                      selfTYpe: 1,
                      memo: t.memo,
                    },
                  })
                }}
              >
                重新申请
              </Button>
            )}
            <Button
              size="small"
              type="link"
              onClick={() => {
                history.push({
                  pathname: "/selfInspectionLegalPractice/add",
                  state: {
                    id: t.id,
                    type: 2,
                    selfTYpe: 2,
                  },
                })
              }}
            >
              详情
            </Button>
          </Space>
        )
      },
    },
  ]
  return cols
}
